import React, { useState, useEffect, useMemo, Fragment } from 'react';
import { useParams } from 'react-router-dom';

import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';

import api from '../../common/apiService';
import { format } from 'date-fns';
import _ from 'lodash';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Button,
  Typography,
  CircularProgress,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Collapse,
  IconButton
} from '@material-ui/core';

import DownIcon from '@material-ui/icons/KeyboardArrowDown';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';

import { Eating, Summary, History } from './components';

import config from '../../config/config.json';
// import MuiAlert from '@material-ui/lab/Alert';
import { useHistory } from 'react-router-dom';
import withAlert from '../../hoc/withAlert';
import emojes from '../../helpers/emojes';

import { useSelector, useDispatch } from 'react-redux';
import {
  initPage,
  getRequestErrorsByPageSelector,
  getPageReadyByPageSelector
} from '../../store/api';

import {
  getOrderDate,
  loadUserCoupons,
  getTeamCouponsSelector,
  getTeamOrderCouponsSelector,
  getTeamTodayCouponsSelector,
  getTeamOrderDateSelector,
  getTeamTodaySelector,
  getTeamOrderForTodaySelector,
  getTeamPageReadySelector,
  loadUserHistory,
  getTeamHistorySelector
} from '../../store/team';

import { getMealSelector } from '../../store/meal';

import { getEventeatingByDateSelector } from '../../store/eventeating';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const getParam = (string, name) => {
  const params = string
    .slice(1)
    .split('&')
    .map(q => q.split('='));
  for (let i = 0; i < params.length; i++) {
    if (params[i][0] === name) {
      return params[i][1];
    }
  }
  return null;
};

const Team = props => {
  const { className, ...rest } = props;
  // Заберем из HOC нужные методы для показа алерта
  const { setSnackMessage, setSnackType, setOpenSnack } = props;

  const token = getParam(props.location.search, 't');
  // console.log('token',token);

  const userId = props.match.params.id;
  let history = useHistory();

  const classes = useStyles();
  const dispatch = useDispatch();

  const orderDate = format(getOrderDate(), 'dd.MM.yyyy');

  const coupons = useSelector(getTeamCouponsSelector);
  const orderCoupons = useSelector(getTeamOrderCouponsSelector);
  const todayCoupons = useSelector(getTeamTodayCouponsSelector);
  const orderForToday = useSelector(getTeamOrderForTodaySelector);
  const mealData = useSelector(getMealSelector);
  const teamHistory = useSelector(getTeamHistorySelector);

  // console.log('mealData', mealData);

  const today = format(new Date(), 'dd.MM.yyyy');

  const [user, setUser] = useState({});
  const [orderRedy, setOrderReady] = useState(false);
  const [gifUrl, setGifUrl] = useState();

  const [blockSubmit, setBlockSubmit] = useState(false);

  const [openHistory, setOpenHistory] = useState(false);
  const [paymentsHistory, setPaymentsHistory] = useState([]);

  const [showBar, setShowBar] = useState(false);

  // const pageReady = useSelector(getPageReadyByPageSelector('/team'));
  const pageReady = useSelector(getTeamPageReadySelector);

  // Грязыный хак что бы не перезагружать Eating каждый раз из-за того что меняется eventeatings
  // Нужно научится правильно пользоваться параметризированными селекторами
  const state = useSelector(state => state);

  const eventeatings = useMemo(() => {
    return getEventeatingByDateSelector(orderDate)(state);
  }, [orderDate, pageReady]);

  let todayEatings;

  if (orderDate === today) {
    // console.log('today');
    todayEatings = eventeatings;
  } else {
    todayEatings = getEventeatingByDateSelector(today)(state);
  }

  const prepareUser = apiUser => {
    if (config.teamCustomerTypes.indexOf(apiUser.customertype_id) == -1) {
      history.replace('/not-found');
    } else {
      setUser(apiUser);
    }
  };

  useEffect(() => {
    const getData = async () => {
      let apiUser = await api.getUser(userId, token);
      prepareUser(apiUser);
      await initPage('/team', dispatch);
      await dispatch(loadUserCoupons(userId, today, token));
    };
    getData();
  }, [dispatch]);

  useEffect(() => {
    const getData = async () => {
      let apiUser = await api.getUser(userId, token);
      prepareUser(apiUser);
    };
    getData();
  }, [orderCoupons]);

  useEffect(() => {
    if (teamHistory) {
      setPaymentsHistory(teamHistory);
    }
  }, [teamHistory]);

  const handelOpenHistory = async () => {
    setOpenHistory(true);
    await dispatch(loadUserHistory({ userId: userId, token }));
  };

  const handleCloseHistory = () => {
    setOpenHistory(false);
  };

  const handleBarOpen = () => {
    setShowBar(!showBar);
  };

  return (
    <React.Fragment>
      {pageReady === false && (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <CircularProgress disableShrink size={56} />
        </div>
      )}

      <Dialog
        scroll="paper"
        fullScreen
        open={openHistory}
        onClose={handleCloseHistory}
        aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{`История платежей`}</DialogTitle>
        <DialogContent>
          <Grid
            container
            direction="column"
            justify="flex-start"
            alignItems="stretch"
            wrap="nowrap"
            spacing={2}>
            {paymentsHistory &&
              paymentsHistory.length > 0 &&
              paymentsHistory.map(h => (
                <Grid item key={h.id}>
                  {/* {h.id} */}
                  <History history={h} />
                </Grid>
              ))}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseHistory} color="primary">
            Закрыть
          </Button>
        </DialogActions>
      </Dialog>

      <div className={classes.root}>
        <div className={classes.content}>
          {pageReady && (
            <>
              <Typography
                variant="h3"
                component="h2"
                style={{ marginBottom: 10 }}>
                Привет, {user.name}
              </Typography>
              {user.customertype_id === config.creditCustomerType &&
                user.visibility === true && (
                  <Typography variant="h5" style={{ marginBottom: 10 }}>
                    <span aria-hidden="true" role="img">
                      💰
                    </span>{' '}
                    Баланс:{' '}
                    <Chip
                      size="small"
                      label={user.balance.toLocaleString('ru')}
                      color={user.balance < 0 ? 'primary' : 'default'}
                    />{' '}
                    <Button
                      color="primary"
                      variant="outlined"
                      size="small"
                      onClick={handelOpenHistory}>
                      История
                    </Button>
                  </Typography>
                )}
              <Typography variant="h5" style={{ marginBottom: 20 }}>
                <span aria-hidden="true" role="img">
                  🛎️
                </span>{' '}
                Заказ можно сделать до 9 утра
              </Typography>
            </>
          )}

          {pageReady && todayCoupons && today && todayCoupons.length > 0 && (
            <Summary date={today} coupons={todayCoupons} />
          )}

          {/* {pageReady && user.customertype_id !== config.creditCustomerType && (
            <>
              <Card>
              <Grid
                      container
                      direction="row"
                      justify="flex-start"
                      alignItems="center"
                      spacing={2}>
                      <Grid item>
                        <Typography
                          variant="h5"
                          style={{ margin: 10 }}
                          onClick={handleBarOpen} gutterBottom>
                          {`Бар `}{' '}
                  <span aria-hidden="true" role="img">
                    {emojes.getRandomFruit()}
                  </span>
                  <span aria-hidden="true" role="img">
                    {emojes.getRandomFruit()}
                  </span>
                  <span aria-hidden="true" role="img">
                    {emojes.getRandomFruit()}
                  </span>{' '}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <IconButton color="inherit" onClick={handleBarOpen}>
                          {showBar ? <UpIcon /> : <DownIcon />}
                        </IconButton>
                      </Grid>
                    </Grid>
      
                <Divider />
                <CardContent>
                  <Fragment>

                    <Collapse in={showBar}>
                      <Eating
                        eventeatings={todayEatings}
                        id={config.mealsId.bar}
                        name={'Бар'}
                        maxChecked={1}
                        maxCheckedPoints={4}
                        customerType={user.customertype_id}
                        token={token}
                        customerId={userId}
                        // orders={orderCoupons.filter(c => c.eating_id === 2)}
                      />
                    </Collapse>
                  </Fragment>
                </CardContent>
              </Card>
              <br />
            </>
          )} */}

          {/* {
      pageReady && orderCoupons && orderDate && orderCoupons.length > 0 && !orderForToday &&
        <Summary date={orderDate}  coupons={orderCoupons}/>
    } */}

          {gifUrl && (
            <div
              style={{
                width: '100%',
                height: 0,
                paddingBottom: '69%',
                position: 'relative'
              }}>
              <iframe
                src={gifUrl}
                width="100%"
                height="100%"
                style={{ position: 'absolute' }}
                frameBorder="0"
                className="giphy-embed"
                allowFullScreen></iframe>
            </div>
          )}

          {/* Показываем блок с заказом только если нет заказынных купонов и еще не было заказа  */}
          {pageReady && (
            // orderCoupons &&
            // orderCoupons.length === 0 &&
            // orderRedy === false && (
            <Card>
              {/* <CardHeader
          title={`Меню на ${orderDate} ${emojes.getRandomFruit()} ${emojes.getRandomFruit()} ${emojes.getRandomFruit()}`}
          /> */}
              <Typography variant="h5" style={{ margin: 10 }} gutterBottom>
                {`Меню на ${orderDate} `}{' '}
                <span aria-hidden="true" role="img">
                  {emojes.getRandomFruit()}
                </span>
                <span aria-hidden="true" role="img">
                  {emojes.getRandomFruit()}
                </span>
                <span aria-hidden="true" role="img">
                  {emojes.getRandomFruit()}
                </span>{' '}
              </Typography>

              <Divider />
              <CardContent>
                <Typography variant="h5" style={{ fontSize: 14 }}>
                  Завтрак
                </Typography>
                <Eating
                  eventeatings={eventeatings}
                  id={config.mealsId.breakfast}
                  name={'Завтрак'}
                  maxChecked={1}
                  maxCheckedPoints={1}
                  customerType={user.customertype_id}
                  token={token}
                  customerId={userId}
                  // orders={orderCoupons.filter(c => c.eating_id === 2)}
                />
                <Typography variant="h5" style={{ fontSize: 14 }}>
                  Обед
                </Typography>
                <Eating
                  eventeatings={eventeatings}
                  id={config.mealsId.dinner}
                  name={'Обед'}
                  maxChecked={2}
                  maxCheckedPoints={2}
                  customerType={user.customertype_id}
                  token={token}
                  customerId={userId}

                  // orders={orderCoupons.filter(c => c.eating_id === 1)}
                />
                <Typography variant="h5" style={{ fontSize: 14 }}>
                  Ужин
                </Typography>
                <Eating
                  eventeatings={eventeatings}
                  id={config.mealsId.supper}
                  name={'Ужин'}
                  maxChecked={1}
                  maxCheckedPoints={1}
                  customerType={user.customertype_id}
                  token={token}
                  customerId={userId}

                  // orders={orderCoupons.filter(c => c.eating_id === 3)}
                />
                <Typography variant="subtitle2" gutterBottom>
                  {' '}
                  <span aria-hidden="true" role="img">
                    😊
                  </span>{' '}
                  На обед можно выбрать два любых блюда. Если нужно больше —
                  пишите Оксане.
                </Typography>
                <Typography variant="subtitle2" gutterBottom>
                  {' '}
                  <span aria-hidden="true" role="img">
                    🙏
                  </span>{' '}
                  Завтрак можно заказать — до 6 утра, а обед и ужин — до 9 утра
                </Typography>
              </CardContent>
              {/* <Divider />
              <CardActions>
                <Button
                  variant="contained"
                  color="primary"
                  // disabled={coupons.length === 0}
                  disabled={blockSubmit || coupons.length === 0}
                  onClick={handleCreateOrder}>
                  Заказать
                </Button>
              </CardActions> */}
            </Card>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default withAlert(Team);
